import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_2 = {
    key: 0,
    class: "bottom10"
};
const _hoisted_3 = { class: "mt-0" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_5 = { class: "input-group top_search" };
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_7 = { class: "input-group top_search" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_9 = { class: "checkbox-wrapper" };
const _hoisted_10 = { class: "float-end float-start-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_button = _resolveComponent("b-button");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _directive_standard_or_higher = _resolveDirective("standard-or-higher");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            (_ctx.reportScheduledModel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("h2", _hoisted_3, [
                        _cache[3] || (_cache[3] = _createTextVNode("Editing schedule report ", -1 /* CACHED */)),
                        _createElementVNode("b", null, _toDisplayString(_ctx.reportScheduledModel.description), 1 /* TEXT */)
                    ])
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        _cache[12] || (_cache[12] = _createTextVNode()),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedCompanyId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCompanyId) = $event)),
                    options: _ctx.companies,
                    "track-by": "value",
                    label: "text",
                    showLabels: false,
                    placeholder: "All companies",
                    class: "multiselect-small"
                }, {
                    noResult: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
            ])
        ]),
        _cache[13] || (_cache[13] = _createTextVNode()),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedSite,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedSite) = $event)),
                    options: _ctx.sitesFiltered,
                    "track-by": "value",
                    label: "text",
                    showLabels: false,
                    placeholder: "Any site",
                    class: "multiselect-small"
                }, {
                    noResult: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
            ])
        ]),
        _cache[14] || (_cache[14] = _createTextVNode()),
        _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_b_form_checkbox, {
                    modelValue: _ctx.query.filterStringsWithNoAlarmOnDetails,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.filterStringsWithNoAlarmOnDetails) = $event)),
                    size: "lg"
                }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode("\r\n\t\t\t\tFilter Strings with no Alarms\r\n\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ])
        ]),
        _cache[15] || (_cache[15] = _createTextVNode()),
        _createElementVNode("div", _hoisted_10, [
            _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.schedule
            }, {
                default: _withCtx(() => [
                    _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fa fa-clock-o" }, null, -1 /* CACHED */)),
                    _createTextVNode(" " + _toDisplayString(_ctx.getScheduleButtonLabel()), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])), [
                [_directive_standard_or_higher]
            ]),
            _cache[10] || (_cache[10] = _createTextVNode()),
            _createVNode(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.exportToPdf
            }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* CACHED */),
                        _createTextVNode(" Export PDF\r\n\t\t", -1 /* CACHED */)
                    ]))]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"]),
            _cache[11] || (_cache[11] = _createTextVNode()),
            _createVNode(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.exportToCsv
            }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* CACHED */),
                        _createTextVNode(" Export CSV\r\n\t\t", -1 /* CACHED */)
                    ]))]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
        ]),
        _cache[16] || (_cache[16] = _createTextVNode()),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ], 64 /* STABLE_FRAGMENT */));
}
